import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Stack } from '@mui/material';
import { SignUpHeaderBar } from 'components';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { PendingApprovalStep } from 'components/SignUpForm/Steps/PendingApprovalStep';
import { usePendingApproval } from 'features/signUp/hooks/usePendingApproval';
import { ConfirmationDialog } from 'components/ConfirmationDialog/ConfirmationDialog';
import { useCobrand } from 'features/cobrand/hooks/useCobrandUtils';
import { NotificationErrorAlert } from 'components/Settings/Sections/NotificationSettings/NotificationErrorAlert';

export const PendingApproval = () => {
  const navigate = useNavigate();
  const { translation } = useTranslationContext();
  const { screenData, isBackButtonDisabled, navigateBack, navigateForward } = usePendingApproval();
  const { cobrand } = useCobrand();
  const [backConfirmationDialogOpen, setBackConfirmationDialogOpen] = useState(false);

  const handleConfirmationDialogNo = () => {
    setBackConfirmationDialogOpen(false);
  };

  const handleConfirmationDialogYes = () => {
    setBackConfirmationDialogOpen(false);
    navigate(-1);
  };

  const { title, description, buttonTitle, bulletPoints, contactLink, image } = screenData;
  return (
    <Stack alignItems="center" height="100dvh" marginX={4}>
      <SignUpHeaderBar
        stepValue={100}
        backButtonDisabled={isBackButtonDisabled}
        onClickBackButton={navigateBack}
        hasProgressBar
      />
      <NotificationErrorAlert />
      <PendingApprovalStep
        title={translation(title)}
        image={image}
        description={translation(description)}
        buttonTitle={buttonTitle ? translation(buttonTitle) : undefined}
        contactLink={contactLink}
        bulletPoints={bulletPoints?.map((point) => ({
          icon: point.icon,
          text: translation(point.text),
        }))}
        onContinue={navigateForward}
      />
      <ConfirmationDialog
        open={backConfirmationDialogOpen}
        // TODO: Add translations https://wellframe.atlassian.net/browse/WFMOB-14201
        title={`Exit ${cobrand.displayName}?`}
        handleYes={handleConfirmationDialogYes}
        yesButtonLabel={translation('general_yes')}
        handleNo={handleConfirmationDialogNo}
        noButtonLabel={translation('general_no')}
      />
    </Stack>
  );
};
